import React from 'react';
import PropTypes from 'prop-types';
import { Card, Form } from 'react-bootstrap-5';

import { reorderableList } from 'helpers/react_dnd/reorderable_list';
import DefaultPageRow from './default_page_row';

export class DefaultPages extends React.Component {
  static propTypes = {
    availablePages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired,
    defaultPages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      key: PropTypes.string.isRequired
    })),
    onRemovePage: PropTypes.func.isRequired,
    onReorderPage: PropTypes.func.isRequired
  }

  render() {
    // The prop may be null if the template was created via duplication
    const defaultPages = this.props.defaultPages || [];

    return (
      <div className="mb-4">
        <div className="my-3">
          <strong className="fw-semibold">Page Defaults</strong> | Click and drag pages to reorder
        </div>
        <p className="my-3">
          The pages that will populate into the "Pages" section of the document editor
        </p>

        {/* Non functional - Needed for spacing alignment */}
        <Form.Group className="search-container invisible mb-3">
          <Form.Control type="text" />
        </Form.Group>

        <Card className="overflow-auto" style={{ maxHeight: '300px' }}>
          <ul className="list-group list-group-flush">
            {defaultPages.map((defaultPage, index) => (
              <DefaultPageRow
                index={index}
                key={defaultPage.key}
                page={this.props.availablePages.find(availablePage => availablePage.id === defaultPage.id)}
                onRemovePage={this.props.onRemovePage}
                onReorder={this.props.onReorderPage}
              />
            ))}
            {defaultPages.length === 0 && (
              <Card.Body>
                <div className="text-center text-muted">
                  Using the default set of pages
                </div>
              </Card.Body>
            )}
          </ul>
        </Card>
      </div>
    );
  }
}

export default reorderableList(DefaultPages);
